<div class="filter-vals">
  <form [formGroup]="form">
    <div class="filter-container">
      <ng-container formArrayName="filters" *ngIf="noData">
        <div class="no-data">No Data Available</div>
      </ng-container>
      <ng-container *ngIf="!noData" formArrayName="filters">
        <ng-container  *ngFor="let val of filterVals; let i = index">
           <div class="filter-val">
          <label
            ><input
              class="chk-box"
              type="checkbox"
              [value]="val.name"
              [checked]="val.checked"
              (change)="onCheckboxChange($event)"
            /><span class="tmp">{{ val.name || nullLabel }}</span></label
          >
        </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="hr-divider"></div>
    <div class="ctrls-input-box" *ngIf="!noData">
      <button class="btn btn-default cst-btn cst-apply" (click)="applyFilter()">Apply</button>
      <button class="btn btn-default cst-btn cst-clear" (click)="clearFilter()">Clear</button>
    </div>
    <div class="ctrls-input-box" *ngIf="noData">
      <!-- Align button to center -->
      <button class="btn btn-default cst-btn cst-clear" (click)="clearFilter()">Close</button>
    </div>
  </form>
</div>

<!--
   
    <ng-container  *ngFor="let val of filterVals">
  
        <div class="filter-val">

            <label><input  class="chk-box" name="selectedvalues"
                type="checkbox" value="val"><span class="tmp">{{val}}</span></label>
       
</div>
    
</ng-container>
<div class='hr-divider'></div>
<div class="ctrls-input-box">

    <button  class="btn btn-default cst-btn cst-apply"
        (click)="applyFilter()">Apply</button>
    <button  class="btn btn-default cst-btn cst-clear"
        (click)="clearFilter()">Clear</button>


</div>

</div>-->
